import { render, staticRenderFns } from "./CreateDealerAction.vue?vue&type=template&id=6356f27c&scoped=true&"
import script from "./CreateDealerAction.vue?vue&type=script&lang=ts&"
export * from "./CreateDealerAction.vue?vue&type=script&lang=ts&"
import style0 from "./CreateDealerAction.vue?vue&type=style&index=0&id=6356f27c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6356f27c",
  null
  
)

export default component.exports